import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import paperCss from './paperCss';
/**
 * @ReactComponent
 *
 * Paper
 */
var Paper = styled.div.attrs(function (_a) {
    var elevation = _a.elevation;
    return ({
        elevation: elevation || 2,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  box-sizing: border-box;\n  display: ", ";\n  ", ";\n"], ["\n  padding: 0;\n  box-sizing: border-box;\n  display: ", ";\n  ", ";\n"])), function (props) { return (props.fullWidth ? 'block' : 'inline-block'); }, paperCss);
export default Paper;
var templateObject_1;
//# sourceMappingURL=Paper.js.map